import { HomeMovesCustomerData } from '@/src/api/home-moves';

export const formatMoveOutAddress = (
  moveOutCustomer?: HomeMovesCustomerData,
): string => {
  if (!moveOutCustomer) {
    return '';
  }

  if (moveOutCustomer?.automaticAddress?.fullAddress) {
    return moveOutCustomer.automaticAddress.fullAddress;
  }

  const addressParts = [
    moveOutCustomer?.manualAddress?.houseNumberOrName,
    moveOutCustomer?.manualAddress?.addressLine1,
    moveOutCustomer?.manualAddress?.addressLine2,
    moveOutCustomer?.manualAddress?.town,
    moveOutCustomer?.manualAddress?.postcode,
  ].filter(Boolean);

  return addressParts.join(', ');
};
